/* ============================================================
   NextSells — interactividad accesible y compatible con Theme Editor
   ============================================================ */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Storefront API sin token (carrito de lectura/escritura). Va a la raíz del dominio: no lleva prefijo de idioma.
  var STOREFRONT_API = "/api/2026-07/graphql.json";
  var CART_CREATE = "mutation NsCodCart($input: CartInput!) @inContext(country: CO, language: ES) {" +
    " cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field code message } } }";
  // Último tramo del field de un userError de cartCreate → campo del formulario.
  var API_FIELDS = { firstName: "name", lastName: "name", phone: "phone", provinceCode: "province", city: "city", address1: "address1", address2: "address2", email: "email", zip: "address1" };

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn, { once: true });
    else fn();
  }

  function findAll(root, selector) {
    var items = [];
    if (root instanceof Element && root.matches(selector)) items.push(root);
    return items.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
  }

  function storefrontRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || (window.routes && window.routes.root_url) || "/";
    return root.replace(/\/?$/, "/") + String(path || "").replace(/^\//, "");
  }

  function fmtMoney(value, symbol, currency) {
    var moneyApi = window.NextSellsMoney;
    var formatter = moneyApi && moneyApi.formatMajorUnits;
    var locale = document.documentElement.lang || "es-CO";
    var country = window.Shopify && window.Shopify.country;
    if (moneyApi && moneyApi.normalizeLocale) locale = moneyApi.normalizeLocale(locale, country);
    else if (/^[a-z]{2}$/i.test(locale) && /^[a-z]{2}$/i.test(country || "")) locale += "-" + country.toUpperCase();
    if (formatter) return formatter(value, symbol, currency, locale);
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency || "COP"
      }).format(Number(value) || 0);
    } catch (error) {
      return (symbol || "$") + String(Number(value) || 0);
    }
  }

  function parseJSON(element, fallback) {
    try {
      return element ? JSON.parse(element.textContent) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function track(method, name, payload) {
    var params = new URLSearchParams(window.location.search);
    var isPreview = Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      params.has("preview_theme_id") ||
      params.has("_fd") ||
      params.has("pb")
    );
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = privacy &&
      typeof privacy.analyticsProcessingAllowed === "function" &&
      privacy.analyticsProcessingAllowed();
    if (isPreview || !allowed || typeof window.fbq !== "function") return;
    window.fbq(method || "track", name, payload || {});
  }

  function variantTitle(title) {
    var value = String(title || "").trim();
    return value && value.toLowerCase() !== "default title" ? value : "";
  }

  function configFor(productId) {
    var configs = document.querySelectorAll("[data-ns-config]");
    for (var i = 0; i < configs.length; i += 1) {
      if (!productId || configs[i].dataset.nsProductId === String(productId)) {
        return parseJSON(configs[i], {});
      }
    }
    return {};
  }

  function initReveal(root) {
    findAll(root, ".ns-reveal:not([data-ns-reveal-init])").forEach(function (element) {
      element.dataset.nsRevealInit = "true";
      if (reducedMotion || !("IntersectionObserver" in window)) {
        element.classList.add("ns-in");
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("ns-in");
          observer.disconnect();
        });
      }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
      observer.observe(element);
    });
  }

  function initMedia(root) {
    findAll(root, "video[autoplay]").forEach(function (video) {
      video.controls = true;
      if (reducedMotion) {
        video.autoplay = false;
        video.removeAttribute("autoplay");
        video.pause();
      }
    });
    initHeroSound(root);
  }

  // Video del hero en una ficha: con sonido si el navegador lo deja. Casi todos exigen un primer toque, y hasta entonces va en silencio.
  function initHeroSound(root) {
    var video = root.querySelector(".ns-hero__frame video[autoplay]");
    if (!video || video.nsSound || window.location.pathname.indexOf("/products/") === -1) return;
    var button = video.closest(".ns-hero__media").querySelector("[data-ns-hero-sound]");
    if (reducedMotion) {
      if (button) button.hidden = true;
      return;
    }
    video.nsSound = true;

    var inView = true;
    var pausedByScroll = false;
    var events = ["pointerup", "touchend", "keydown"];
    var settled = false;

    // Mientras se prueba si el navegador deja sonar, el botón no cambia: si no, parpadea al cargar.
    function syncButton() {
      if (settled && button) button.setAttribute("aria-pressed", video.muted ? "false" : "true");
    }
    function settle() {
      settled = true;
      syncButton();
    }

    function play() {
      var started = video.play();
      return started && started.catch ? started : Promise.resolve();
    }
    function fallBackToMuted() {
      video.muted = true;
      settle();
      play().catch(function () {});
      events.forEach(function (name) { document.addEventListener(name, onGesture, true); });
    }
    function unmute() {
      events.forEach(function (name) { document.removeEventListener(name, onGesture, true); });
      video.muted = false;
      if (inView) play().catch(fallBackToMuted);
    }
    function onGesture(event) {
      // El botón de sonido decide por su cuenta: si se activara aquí, su clic lo volvería a silenciar.
      if (button && button.contains(event.target)) return;
      // Un dedo que solo desplaza no cuenta como toque, y quitar el silencio sin toque pausaría el video.
      if (navigator.userActivation && !navigator.userActivation.isActive) return;
      // Sobre el video puede ser su propio botón de sonido: se le deja actuar primero para no deshacerlo.
      if (event.target === video) {
        window.setTimeout(function () { if (video.muted) unmute(); }, 50);
        events.forEach(function (name) { document.removeEventListener(name, onGesture, true); });
      } else {
        unmute();
      }
    }

    // Solo un video suena a la vez.
    document.addEventListener("play", function (event) {
      if (!event.target || event.target.tagName !== "VIDEO") return;
      findAll(document, "video").forEach(function (other) {
        if (other !== event.target && !other.paused) other.pause();
      });
      if (event.target !== video) pausedByScroll = false;
    }, true);

    // Con sonido no puede seguir sonando mientras el cliente llena el formulario.
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        if (!inView && !video.paused) {
          pausedByScroll = true;
          video.pause();
        } else if (inView && pausedByScroll) {
          pausedByScroll = false;
          play().catch(function () {});
        }
      }, { threshold: 0.25 }).observe(video);
    }

    if (button) {
      button.addEventListener("click", function () {
        if (video.muted) unmute();
        else video.muted = true;
      });
    }
    video.addEventListener("volumechange", syncButton);

    video.muted = false;
    play().then(settle).catch(fallBackToMuted);
  }

  // Dawn fija --header-height en :root; al subir, el header fijo reaparece y taparía el destino del ancla.
  function headerOffset() {
    var height = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
    return (Number.isFinite(height) ? height : 0) + 16;
  }

  function initAnchors() {
    if (document.documentElement.dataset.nsAnchorsInit) return;
    document.documentElement.dataset.nsAnchorsInit = "true";
    document.addEventListener("click", function (event) {
      var anchor = event.target.closest('a[href^="#ns-"]');
      if (!anchor) return;
      var href = anchor.getAttribute("href");
      var productScope = anchor.closest("[data-ns-product-id], [data-ns-anchor-product-id]");
      var productId = anchor.dataset.nsProductId ||
        (productScope && (productScope.dataset.nsProductId || productScope.dataset.nsAnchorProductId)) || "";
      var productSelector = productId ? '[data-ns-product-id="' + productId + '"]' : "";
      var target = null;
      if (href === "#ns-pedido") {
        target = document.querySelector("[data-ns-order-section]" + productSelector);
      } else if (href === "#ns-video") {
        target = productId
          ? document.querySelector('[data-ns-video-section][data-ns-anchor-product-id="' + productId + '"]')
          : document.querySelector("[data-ns-video-section]");
      } else if (href === "#ns-descripcion") {
        target = productId
          ? document.querySelector('[data-ns-product-content][data-ns-anchor-product-id="' + productId + '"]')
          : document.querySelector("[data-ns-product-content]");
      } else {
        target = document.getElementById(href.slice(1));
      }
      if (!target) return;
      event.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: y, behavior: reducedMotion ? "auto" : "smooth" });
      var focusTarget = target.querySelector("select, input, button, a[href]");
      if (focusTarget) window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, reducedMotion ? 0 : 350);
    });
  }

  function restoreLegacyHash() {
    var selectors = {
      "#ns-pedido": "[data-ns-order-section]",
      "#ns-video": "[data-ns-video-section]",
      "#ns-descripcion": "[data-ns-product-content]"
    };
    var selector = selectors[window.location.hash];
    var target = selector && document.querySelector(selector);
    if (!target) return;
    window.requestAnimationFrame(function () {
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: y, behavior: "auto" });
    });
  }

  function refreshWaLinks(detail) {
    document.querySelectorAll(".ns-wa-link").forEach(function (anchor) {
      var anchorProductId = anchor.dataset.nsProductId;
      if (!anchorProductId && !anchor.hasAttribute("data-ns-wamsg")) return;
      var cfg = configFor(anchorProductId || (detail && detail.productId));
      var number = String(cfg.wa || "").replace(/[^0-9]/g, "");
      var message = anchor.dataset.nsWamsg || cfg.msg || "";
      var detailTitle = detail && variantTitle(detail.title);
      if (detailTitle && (!anchorProductId || String(detail.productId) === String(anchorProductId))) {
        message += "\nVariante: " + detailTitle;
        if (detail.sku) message += " (SKU: " + detail.sku + ")";
        if (!detail.available) message += " — actualmente agotada";
      }
      if (number) {
        anchor.href = "https://wa.me/" + number + (message ? "?text=" + encodeURIComponent(message) : "");
        anchor.target = "_blank";
        anchor.rel = "noopener";
      }
    });
  }

  function initWaLinks(root) {
    refreshWaLinks();
    findAll(root, ".ns-wa-link:not([data-ns-wa-init])").forEach(function (anchor) {
      anchor.dataset.nsWaInit = "true";
      anchor.addEventListener("click", function () {
        track("track", "Contact", { content_category: "whatsapp" });
      });
    });
  }

  function setStickyVisibility(bar, visible) {
    bar.classList.toggle("ns-show", visible);
    bar.setAttribute("aria-hidden", visible ? "false" : "true");
    if ("inert" in bar) bar.inert = !visible;
    bar.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function (control) {
      if (!visible) {
        if (control.getAttribute("tabindex") !== "-1") control.dataset.nsTabindex = control.getAttribute("tabindex") || "";
        control.setAttribute("tabindex", "-1");
      } else if (control.dataset.nsTabindex !== undefined) {
        if (control.dataset.nsTabindex) control.setAttribute("tabindex", control.dataset.nsTabindex);
        else control.removeAttribute("tabindex");
        delete control.dataset.nsTabindex;
      }
    });
  }

  function initSticky(root) {
    findAll(root, "[data-ns-sticky]:not([data-ns-sticky-init])").forEach(function (bar) {
      bar.dataset.nsStickyInit = "true";
      var productId = bar.dataset.nsProductId;
      var hero = productId
        ? document.querySelector('.ns-hero[data-ns-product-id="' + productId + '"]')
        : document.querySelector(".ns-hero");
      var order = productId
        ? document.querySelector('[data-ns-order-section][data-ns-product-id="' + productId + '"]')
        : document.querySelector("[data-ns-order-section]");
      var controller = new AbortController();
      function update() {
        var trigger = hero ? hero.offsetTop + hero.offsetHeight - 200 : 480;
        var show = window.pageYOffset > trigger;
        if (show && order) {
          var rect = order.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) show = false;
        }
        setStickyVisibility(bar, show);
      }
      window.addEventListener("scroll", update, { passive: true, signal: controller.signal });
      window.addEventListener("resize", update, { passive: true, signal: controller.signal });
      bar._nsCleanup = function () { controller.abort(); };
      update();
    });
  }

  function activateTab(wrap, tab, moveFocus) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll("[data-ns-tab]"));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll("[data-ns-panel]"));
    var index = tab.dataset.nsTab;
    tabs.forEach(function (item) {
      var active = item === tab;
      item.setAttribute("aria-selected", active ? "true" : "false");
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach(function (panel) {
      var active = panel.dataset.nsPanel === index;
      panel.dataset.active = active ? "true" : "false";
      panel.hidden = !active;
    });
    if (moveFocus) tab.focus();
  }

  function initTabs(root) {
    findAll(root, "[data-ns-tabs]:not([data-ns-tabs-init])").forEach(function (wrap) {
      wrap.dataset.nsTabsInit = "true";
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll("[data-ns-tab]"));
      tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () { activateTab(wrap, tab, false); });
        tab.addEventListener("keydown", function (event) {
          var next = index;
          if (event.key === "ArrowRight" || event.key === "ArrowDown") next = (index + 1) % tabs.length;
          else if (event.key === "ArrowLeft" || event.key === "ArrowUp") next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === "Home") next = 0;
          else if (event.key === "End") next = tabs.length - 1;
          else return;
          event.preventDefault();
          activateTab(wrap, tabs[next], true);
        });
      });
      var selected = wrap.querySelector('[data-ns-tab][aria-selected="true"]') || tabs[0];
      if (selected) activateTab(wrap, selected, false);
    });
  }

  function updateProductUI(detail) {
    var selector = '[data-ns-product-id="' + detail.productId + '"]';
    document.querySelectorAll(selector).forEach(function (scope) {
      scope.querySelectorAll("[data-ns-price]").forEach(function (element) {
        element.textContent = fmtMoney(detail.price, detail.symbol, detail.currency);
      });
      scope.querySelectorAll("[data-ns-compare-price]").forEach(function (element) {
        var show = detail.compareAtPrice > detail.price;
        element.hidden = !show;
        if (show) element.textContent = fmtMoney(detail.compareAtPrice, detail.symbol, detail.currency);
      });
      scope.querySelectorAll("[data-ns-availability]").forEach(function (element) {
        element.textContent = detail.available ? "Disponible" : "Agotado";
        element.dataset.available = detail.available ? "true" : "false";
      });
      scope.querySelectorAll("[data-ns-dynamic-product-media]").forEach(function (media) {
        var image = media.querySelector(".ns-dynamic-product-image");
        if (!media.dataset.nsFallbackKind) {
          media.dataset.nsFallbackKind = image ? "image" : "placeholder";
          media._nsFallbackMarkup = media.innerHTML;
          media._nsFallbackSrc = image ? (image.currentSrc || image.src) : "";
        }

        if (detail.image) {
          if (!image) {
            image = document.createElement("img");
            image.className = "ns-dynamic-product-image";
            image.alt = media.dataset.nsMediaAlt || "Producto NextSells";
            image.loading = "lazy";
            media.replaceChildren(image);
          }
          image.src = detail.image;
          image.removeAttribute("srcset");
          return;
        }

        if (media.dataset.nsFallbackKind === "placeholder") {
          if (media.innerHTML !== media._nsFallbackMarkup) media.innerHTML = media._nsFallbackMarkup;
          return;
        }

        image = media.querySelector(".ns-dynamic-product-image");
        if (image && media._nsFallbackSrc) {
          image.src = media._nsFallbackSrc;
          image.removeAttribute("srcset");
        }
      });
    });
    refreshWaLinks(detail);
  }

  function initOrderForm(form) {
    if (form.dataset.nsOrderInit) return;
    form.dataset.nsOrderInit = "true";

    var variants = parseJSON(form.querySelector("[data-ns-variants]"), []);
    var selector = form.querySelector("[data-ns-variant-selector]");
    var hiddenVariant = form.querySelector("[data-ns-variant-input]");
    var quantityInput = form.querySelector("[data-ns-qty]");
    var usageInput = form.querySelector("[data-ns-usage]");
    var buyButton = form.querySelector("[data-ns-buy]");
    var whatsappButton = form.querySelector("[data-ns-wabtn]");
    var status = form.querySelector("[data-ns-order-status]");
    var symbol = form.dataset.symbol || "$";
    var currency = form.dataset.currency || "COP";
    var productId = form.dataset.nsProductId || "";
    var productName = form.dataset.product || "Producto";
    var formId = form.dataset.nsFormId || form.id || "";
    var whatsappNumber = String(form.dataset.wa || "").replace(/[^0-9]/g, "");
    var shippingText = form.dataset.shipping || "Gratis a toda Colombia";
    var buyerInputs = {};
    form.querySelectorAll("[data-ns-buyer]").forEach(function (input) { buyerInputs[input.dataset.nsBuyer] = input; });
    var hasBuyerFields = Boolean(buyerInputs.name);
    var submitting = false;
    var controller = new AbortController();
    form._nsCleanup = function () { controller.abort(); };

    function quantity() {
      var value = parseInt(quantityInput ? quantityInput.value : "1", 10);
      if (!Number.isFinite(value)) value = 1;
      value = Math.max(1, Math.min(20, value));
      if (quantityInput) quantityInput.value = value;
      return value;
    }

    function currentVariant() {
      var id = selector ? selector.value : (hiddenVariant ? hiddenVariant.value : form.dataset.variant);
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return {
        id: id,
        title: "",
        sku: "",
        available: form.dataset.available !== "false",
        price: Number(form.dataset.unit) || 0,
        compareAtPrice: 0,
        image: null
      };
    }

    function setStatus(message, isError, focus) {
      if (!status) return;
      status.textContent = message || "";
      status.dataset.error = isError ? "true" : "false";
      status.setAttribute("role", isError ? "alert" : "status");
      if (focus && message) status.focus();
    }

    function setBusy(busy) {
      submitting = busy;
      var variant = currentVariant();
      if (buyButton) {
        buyButton.disabled = busy || !variant.available || !variant.id;
        buyButton.setAttribute("aria-disabled", buyButton.disabled ? "true" : "false");
      }
      if (whatsappButton) whatsappButton.disabled = busy || !whatsappNumber;
      form.setAttribute("aria-busy", busy ? "true" : "false");
    }

    function update(options) {
      var variant = currentVariant();
      var count = quantity();
      form.dataset.variant = variant.id || "";
      form.dataset.unit = variant.price || 0;
      form.dataset.available = variant.available ? "true" : "false";
      var quantityLabel = form.querySelector("[data-ns-qtylabel]");
      var subtotal = form.querySelector("[data-ns-subtotal]");
      if (quantityLabel) quantityLabel.textContent = "×" + count;
      if (subtotal) subtotal.textContent = fmtMoney(variant.price * count, symbol, currency);
      if (buyButton) {
        buyButton.disabled = !variant.available || !variant.id;
        buyButton.setAttribute("aria-disabled", buyButton.disabled ? "true" : "false");
      }
      if (whatsappButton) whatsappButton.disabled = !whatsappNumber;
      setStatus(variant.available ? "" : "La variante seleccionada está agotada. Puedes elegir otra opción o consultarnos por WhatsApp.", !variant.available, false);
      var detail = {
        productId: productId,
        id: variant.id,
        title: variant.title,
        sku: variant.sku,
        available: Boolean(variant.available),
        price: Number(variant.price) || 0,
        compareAtPrice: Number(variant.compareAtPrice) || 0,
        image: variant.image,
        symbol: symbol,
        currency: currency,
        quantity: count,
        sourceFormId: formId
      };
      updateProductUI(detail);
      if (!options || options.broadcast !== false) {
        document.dispatchEvent(new CustomEvent("ns:variant-change", { detail: detail }));
      }
      if (options && options.updateUrl && variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    function selectedUsage() {
      return usageInput ? usageInput.value.trim() : "";
    }

    function addToCart(variant) {
      var properties = {};
      if (selectedUsage()) properties["Uso opcional"] = selectedUsage();
      return fetch(storefrontRoute("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: quantity(), properties: properties }] })
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || "No fue posible agregar el producto.");
        });
      });
    }

    function buyerValue(key) {
      var input = buyerInputs[key];
      return input ? String(input.value || "").replace(/\s+/g, " ").trim() : "";
    }

    // Celular colombiano a E.164: 3001234567, 300 123 4567, +57 300… o 57300… → +573001234567.
    function normalizePhone(raw) {
      var digits = String(raw || "").replace(/[^0-9]/g, "");
      if (digits.length === 12 && digits.indexOf("57") === 0) digits = digits.slice(2);
      return /^3\d{9}$/.test(digits) ? "+57" + digits : "";
    }

    // message: false limpia el campo; true muestra el error por defecto; un texto lo reemplaza.
    function markField(key, message) {
      var input = buyerInputs[key];
      if (!input) return;
      var error = form.querySelector('[data-ns-buyer-error="' + key + '"]');
      input.classList.toggle("ns-invalid", Boolean(message));
      input.setAttribute("aria-invalid", message ? "true" : "false");
      if (!error) return;
      if (!error.dataset.nsDefault) error.dataset.nsDefault = error.textContent;
      error.textContent = typeof message === "string" ? message : error.dataset.nsDefault;
    }

    // Devuelve los datos listos para la Storefront API, o null tras marcar lo que falta.
    function validateBuyer() {
      var name = buyerValue("name");
      var parts = name.split(" ").filter(Boolean);
      var phone = normalizePhone(buyerValue("phone"));
      var email = buyerValue("email");
      var address1 = buyerValue("address1");
      var problems = {
        name: parts.length < 2,
        phone: !phone,
        province: !buyerValue("province"),
        city: buyerValue("city").length < 2,
        address1: address1.length < 5,
        email: Boolean(email) && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)
      };
      var first = null;
      Object.keys(problems).forEach(function (key) {
        markField(key, problems[key]);
        if (problems[key] && !first) first = buyerInputs[key];
      });
      if (first) {
        setStatus("Revisa los datos de entrega marcados.", true, false);
        first.focus();
        return null;
      }
      return {
        firstName: parts[0],
        lastName: parts.slice(1).join(" "),
        phone: phone,
        email: email,
        provinceCode: buyerValue("province"),
        city: buyerValue("city"),
        address1: address1,
        address2: buyerValue("address2")
      };
    }

    // Carrito de la Storefront API (sin token) con la dirección puesta: su checkoutUrl abre el
    // checkout de Shopify ya lleno. El id del carrito lleva una clave secreta: no se guarda ni se loguea.
    function createPrefilledCart(variant, buyer) {
      var address = {
        firstName: buyer.firstName,
        lastName: buyer.lastName,
        address1: buyer.address1,
        city: buyer.city,
        provinceCode: buyer.provinceCode,
        countryCode: "CO",
        phone: buyer.phone
      };
      if (buyer.address2) address.address2 = buyer.address2;
      var identity = { phone: buyer.phone, countryCode: "CO" };
      if (buyer.email) identity.email = buyer.email;
      var line = { merchandiseId: "gid://shopify/ProductVariant/" + variant.id, quantity: quantity() };
      if (selectedUsage()) line.attributes = [{ key: "Uso opcional", value: selectedUsage() }];
      var input = {
        lines: [line],
        buyerIdentity: identity,
        delivery: { addresses: [{ selected: true, oneTimeUse: true, validationStrategy: "STRICT", address: { deliveryAddress: address } }] }
      };
      // Sin respuesta en 8 s se cae al carrito de siempre: una conexión colgada no deja el formulario bloqueado.
      var abort = new AbortController();
      var timer = window.setTimeout(function () { abort.abort(); }, 8000);
      return fetch(STOREFRONT_API, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ query: CART_CREATE, variables: { input: input } }),
        signal: abort.signal
      }).then(function (response) {
        window.clearTimeout(timer);
        if (!response.ok) throw new Error("Storefront API " + response.status);
        return response.json();
      }).then(function (json) {
        var result = json && json.data && json.data.cartCreate;
        if (!result) throw new Error("Storefront API sin cartCreate");
        if (result.userErrors && result.userErrors.length) {
          var invalid = new Error("Datos de entrega rechazados");
          invalid.userErrors = result.userErrors;
          throw invalid;
        }
        if (!result.cart || !result.cart.checkoutUrl) throw new Error("Storefront API sin checkoutUrl");
        return result.cart.checkoutUrl;
      });
    }

    function showApiErrors(errors) {
      var first = null;
      errors.forEach(function (error) {
        var path = [].concat(error.field || []);
        var key = null;
        for (var i = path.length - 1; i >= 0 && !key; i -= 1) key = API_FIELDS[path[i]] || null;
        if (!key && error.code === "PROVINCE_NOT_FOUND") key = "province";
        if (key && buyerInputs[key]) {
          // Shopify devuelve varios de estos mensajes en inglés aunque se pida español: se usa el nuestro.
          markField(key, true);
          if (!first) first = buyerInputs[key];
        }
      });
      if (first) {
        setStatus("Shopify no reconoce algún dato de entrega. Revisa los campos marcados.", true, false);
        first.focus();
      } else {
        setStatus("No pudimos preparar tu pedido. Inténtalo nuevamente o escríbenos por WhatsApp.", true, true);
      }
    }

    function whatsappText(variant, buyer) {
      var lines = ["Hola NextSells, quiero hacer este pedido:", "", "🛒 " + productName];
      var selectedTitle = variantTitle(variant.title);
      if (selectedTitle) lines.push("Variante: " + selectedTitle);
      if (variant.sku) lines.push("SKU: " + variant.sku);
      lines.push("Cantidad: " + quantity());
      lines.push("Subtotal: " + fmtMoney(variant.price * quantity(), symbol, currency));
      lines.push("Envío: " + shippingText);
      if (buyer) {
        lines.push("", "Datos de entrega:");
        lines.push("Nombre: " + buyer.firstName + " " + buyer.lastName);
        lines.push("Celular: " + buyer.phone);
        lines.push("Departamento: " + buyerInputs.province.options[buyerInputs.province.selectedIndex].text);
        lines.push("Ciudad: " + buyer.city);
        lines.push("Dirección: " + buyer.address1);
        if (buyer.address2) lines.push("Barrio, apto o referencia: " + buyer.address2);
        if (buyer.email) lines.push("Correo: " + buyer.email);
      }
      if (!variant.available) lines.push("Nota: esta variante aparece agotada; quisiera conocer alternativas.");
      return lines.join("\n");
    }

    if (selector) selector.addEventListener("change", function () { update({ updateUrl: true }); }, { signal: controller.signal });
    if (quantityInput) quantityInput.addEventListener("input", function () { update(); }, { signal: controller.signal });
    var plus = form.querySelector("[data-ns-qtyplus]");
    var minus = form.querySelector("[data-ns-qtyminus]");
    if (plus) plus.addEventListener("click", function () { quantityInput.value = quantity() + 1; update(); }, { signal: controller.signal });
    if (minus) minus.addEventListener("click", function () { quantityInput.value = quantity() - 1; update(); }, { signal: controller.signal });

    Object.keys(buyerInputs).forEach(function (key) {
      var clear = function () { if (buyerInputs[key].classList.contains("ns-invalid")) markField(key, false); };
      buyerInputs[key].addEventListener("input", clear, { signal: controller.signal });
      buyerInputs[key].addEventListener("change", clear, { signal: controller.signal });
    });

    var chips = form.querySelectorAll("[data-ns-chip]");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var pressed = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", pressed ? "false" : "true");
        var values = [];
        chips.forEach(function (item) {
          if (item.getAttribute("aria-pressed") === "true") values.push(item.dataset.nsChip);
        });
        if (usageInput) usageInput.value = values.join(", ");
      }, { signal: controller.signal });
    });

    // Safari anterior a 15.4 no tiene event.submitter: sin esto, el clic en WhatsApp se tomaría como una compra.
    var lastClicked = null;
    [buyButton, whatsappButton].forEach(function (button) {
      if (button) button.addEventListener("click", function () { lastClicked = button; }, { signal: controller.signal });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (submitting) return;
      var submitter = event.submitter || lastClicked || buyButton;
      lastClicked = null;
      var isWhatsapp = submitter && submitter.hasAttribute("data-ns-wabtn");
      var variant = currentVariant();

      if (!variant.id) {
        setStatus("Selecciona un producto válido antes de continuar.", true, true);
        return;
      }

      // Los dos botones exigen los datos de entrega: WhatsApp no abre hasta que estén completos.
      var buyer = null;
      if (hasBuyerFields) {
        buyer = validateBuyer();
        if (!buyer) return;
      }

      if (isWhatsapp) {
        if (!whatsappNumber) {
          setStatus("El número de WhatsApp todavía no está configurado.", true, true);
          return;
        }
        var whatsappUrl = "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(whatsappText(variant, buyer));
        var opened = window.open("", "_blank");
        if (opened) {
          opened.opener = null;
          opened.location = whatsappUrl;
        }
        track("track", "Lead", {
          value: variant.price * quantity(),
          currency: currency,
          content_ids: [String(variant.id)],
          content_type: "product",
          content_category: "whatsapp",
          num_items: quantity()
        });
        track("trackCustom", "PedidoWhatsApp", { value: variant.price * quantity(), currency: currency });
        if (!opened) window.location.assign(whatsappUrl);
        else setStatus("WhatsApp se abrió en una nueva pestaña.", false, false);
        return;
      }

      if (!variant.available) {
        setStatus("Esta variante está agotada. Elige otra opción para continuar.", true, true);
        return;
      }

      setBusy(true);
      setStatus("Preparando tu pedido…", false, false);
      var plainCheckout = function () {
        return addToCart(variant).then(function () { return storefrontRoute("checkout"); });
      };
      var checkout = buyer
        ? createPrefilledCart(variant, buyer).catch(function (error) {
            if (error.userErrors) throw error;
            // La Storefront API no respondió: el pedido sigue por el carrito de siempre, sin prefill.
            return plainCheckout();
          })
        : plainCheckout();
      checkout.then(function (checkoutUrl) {
        track("track", "AddToCart", {
          value: variant.price * quantity(),
          currency: currency,
          content_ids: [String(variant.id)],
          content_type: "product",
          num_items: quantity()
        });
        track("track", "InitiateCheckout", {
          value: variant.price * quantity(),
          currency: currency,
          content_ids: [String(variant.id)],
          content_type: "product",
          num_items: quantity()
        });
        track("trackCustom", "PedidoCheckout", { value: variant.price * quantity(), currency: currency });
        window.location.assign(checkoutUrl);
      }).catch(function (error) {
        setBusy(false);
        if (error.userErrors) {
          showApiErrors(error.userErrors);
          return;
        }
        // Un TypeError es el fallo de red del navegador ("Failed to fetch"): no se le muestra al comprador.
        var message = error instanceof TypeError ? "" : error.message;
        setStatus(message || "No pudimos preparar tu pedido. Inténtalo nuevamente o escríbenos por WhatsApp.", true, true);
      });
    }, { signal: controller.signal });

    // Al volver atrás desde el checkout el navegador puede restaurar la página tal como quedó: en "Preparando…".
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      setBusy(false);
      setStatus("", false, false);
    }, { signal: controller.signal });

    document.addEventListener("ns:variant-change", function (event) {
      var detail = event.detail || {};
      if (String(detail.productId) !== String(productId) || detail.sourceFormId === formId) return;
      if (selector && selector.querySelector('option[value="' + detail.id + '"]')) selector.value = String(detail.id);
      if (hiddenVariant) hiddenVariant.value = String(detail.id || "");
      if (quantityInput && detail.quantity) quantityInput.value = detail.quantity;
      update({ broadcast: false });
    }, { signal: controller.signal });

    update();
  }

  function initOrders(root) {
    findAll(root, "[data-ns-order]").forEach(initOrderForm);
  }

  function initAll(root) {
    initReveal(root);
    initMedia(root);
    initWaLinks(root);
    initSticky(root);
    initTabs(root);
    initOrders(root);
  }

  ready(function () {
    initAnchors();
    initAll(document);
    restoreLegacyHash();
    document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
    document.addEventListener("shopify:block:select", function (event) {
      var panel = event.target.closest && event.target.closest("[data-ns-panel]");
      if (!panel) return;
      var wrap = panel.closest("[data-ns-tabs]");
      var tab = wrap && wrap.querySelector('[data-ns-tab="' + panel.dataset.nsPanel + '"]');
      if (wrap && tab) activateTab(wrap, tab, false);
    });
    document.addEventListener("shopify:section:unload", function (event) {
      findAll(event.target, "[data-ns-sticky]").forEach(function (bar) {
        if (bar._nsCleanup) bar._nsCleanup();
      });
      findAll(event.target, "[data-ns-order]").forEach(function (form) {
        if (form._nsCleanup) form._nsCleanup();
      });
    });
  });
})();
